import React from 'react';
import { Route } from 'react-router-dom';
import BoardPage from './BoardPage';

export const routes = [<Route key="1" path="/projects/:projectId/board" component={BoardPage} />];

export const navigation = [{ name: 'board', link: '/Board' }];
